
/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'

import Img from 'components/Img'

import AwardIcon from './images/award.svg'

import './style'
import './media'

/*Images*/

const AwardItem = props => (
    <div className={c("award-item", props.className)}>
        <Img src={AwardIcon} className="award-icon"/>
        <div className="award-title">
            {props.title}
        </div>
        <div className="award-text">
            {props.children}
        </div>
    </div>
) 

export default AwardItem